import React, { useState, useEffect } from 'react';
import ApplicationRouter from 'routes';
import './styles/main.scss';
import { getSystemLocales } from 'store/forms/actions';
import { useDispatch } from 'react-redux';

const App = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const storedLanguage = localStorage.getItem('appLanguage') || process.env.REACT_APP_DEFAULT_APP_LANGUAGE;
    //console.log(`App component dispatching getSystemLocales for language: ${storedLanguage}`);
    dispatch(getSystemLocales(storedLanguage));
  }, [dispatch]);

  return (
    <div className="app-container">
      <ApplicationRouter />
    </div>
  );
};

export default App;